import { render, staticRenderFns } from "./subscribeuser.vue?vue&type=template&id=56393fd5&scoped=true&"
import script from "./subscribeuser.vue?vue&type=script&lang=js&"
export * from "./subscribeuser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56393fd5",
  null
  
)

export default component.exports